// extracted by mini-css-extract-plugin
export default {"badge":"badge_badge__ib3OF","warning":"badge_warning__g-Pz8","info":"badge_info__vQzwo","success":"badge_success__x58jg","error":"badge_error__ZNFpY"};